import '../../FairnessModal.scss'
import { CopyIcon } from 'assets/icons/index'
import { DEFAULT_GAME_ID } from 'constants/index'
import { PLINKO_GAME_RISK_LEVEL_OBJ } from 'games/Plinko/GameTheme/PyramidPlinkoGame/pyramidPlinkogame.constants'
import { generateClientSeed } from 'helpers/common.helpers'
import { useDispatch, useSelector } from 'react-redux'
import { setNewClientSeed } from 'redux-store/redux/slices/gameSettings.slice'
import { useTranslation } from 'react-i18next'


const SeedsTab = ({ gameId, handleCopyCode, resultData }) => {
  const {t} = useTranslation()
  const dispatch = useDispatch()
  const { clientSeed: updatedCLientSeed } = useSelector(state => state.gameSetting)

  const handleGenerateNewClientSeed = (e) => {
    e.preventDefault()
    dispatch(setNewClientSeed(generateClientSeed()))
  }

  if (+gameId === +DEFAULT_GAME_ID.CRASH || +gameId === +DEFAULT_GAME_ID.CHOPPER_CRASH || +gameId === +DEFAULT_GAME_ID.MULTI_CRASH || +gameId === +DEFAULT_GAME_ID.SOCCER_CRASH) {
    return (
      <div>
        <div className='form-group'>
          <label className='form-label'>Last Bet Crash Rate</label>
          <div className='input-group'>
            <input
              type='text'
              className='form-control shadow-none'
              style={{ paddingLeft: '1rem', paddingRight: '3.5rem' }}
              value={resultData[0]?.crashRate}
              placeholder='Last Bet Crash Rate'
            />
            <div className='position-absolute top-0 bottom-0 end-0 custom-input-group-addons'>
              <button type='button' className='input-btn'>
                <CopyIcon width='22' height='22' fill='var(--themeGreyText)' onClick={() => handleCopyCode(resultData[0]?.crashRate || '')} />
              </button>
            </div>
          </div>
        </div>
        <div className='form-group'>
          <label className='form-label'>Last Bet Round Hash</label>
          <div className='input-group'>
            <input
              type='text'
              className='form-control shadow-none'
              style={{ paddingLeft: '1rem', paddingRight: '3.5rem' }}
              value={resultData[0]?.roundHash}
              placeholder='Last Bet Round Hash'
            />
            <div className='position-absolute top-0 bottom-0 end-0 custom-input-group-addons'>
              <button type='button' className='input-btn' onClick={() => handleCopyCode(resultData[0]?.roundHash) || ''}>
                <CopyIcon width='22' height='22' fill='var(--themeGreyText)' />
              </button>
            </div>
          </div>
        </div>
        <div className='form-group'>
          <label className='form-label'>Current Round Signature</label>
          <div className='input-group'>
            <input
              type='text'
              min={0}
              placeholder='0'
              className='form-control shadow-none'
              value={resultData[0]?.roundSignature}
            />
          </div>
        </div>
        <hr />
        <h6 className='body-heading'>{t('GENERATE_NEW_CLIENT_SEED')}</h6>
        <div className='form-group'>
          <label className='form-label'>{t('NEXT_CLIENT_SEED')}</label>
          <div className='row gx-2'>
            <div className='col'>
              <div className='input-group'>
                <div
                  // type='text'
                  className='form-control py-1 shadow-none toast-body custom-text-field'
                  rows='1'
                  style={{ paddingLeft: '1rem', paddingRight: '1rem', width: '80%' }}
                  disabled
                  placeholder={t('NEXT_CLIENT_SEED')}
                >{updatedCLientSeed}</div>
              </div>
            </div>
            <div className='col-auto'>
              <button className='btn gradient-btn text-capitalize generate-btn' onClick={handleGenerateNewClientSeed}>
                {t('GENERATE')}
              </button>
            </div>
          </div>
        </div>
      </div>

    )
  } else if (+gameId === +DEFAULT_GAME_ID.PLINKO) {
    return (
      <>
        <div className='form-group mb-3'>
          <label className='form-label'>{t('BET_CLIENT_SEED')}</label>
          <div className='input-group'>
            <input
              type='text'
              className='form-control shadow-none'
              style={{ paddingLeft: '1rem', paddingRight: '3.5rem' }}
              value={resultData?.clientSeed}
              disabled
              placeholder='Client Seed'
            />
            <div className='position-absolute top-0 bottom-0 end-0 custom-input-group-addons'>
              <button type='button' className='input-btn' onClick={() => handleCopyCode(resultData?.clientSeed)}>
                <CopyIcon width='22' height='22' fill='var(--themeGreyText)' />
              </button>
            </div>
          </div>
        </div>
        <div className='form-group mb-3'>
          <label className='form-label'>{t('BET_SERVER_SEED')}</label>
          <div className='input-group'>
            <input
              type='text'
              className='form-control shadow-none'
              style={{ paddingLeft: '1rem', paddingRight: '3.5rem' }}
              value={resultData?.serverSeed}
              disabled
              placeholder= {t('SERVER_SEED')}
            />
            <div className='position-absolute top-0 bottom-0 end-0 custom-input-group-addons'>
              <button type='button' className='input-btn' onClick={() => handleCopyCode(resultData?.serverSeed)}>
                <CopyIcon width='22' height='22' fill='var(--themeGreyText)' />
              </button>
            </div>
          </div>
        </div>
        <div className='form-group mb-3'>
          <label className='form-label'>{t('LAST_BET_RISK')}</label>
          <div className='input-group'>
            <input
              type='text'
              className='form-control shadow-none'
              style={{ paddingLeft: '1rem', paddingRight: '3.5rem' }}
              value={PLINKO_GAME_RISK_LEVEL_OBJ[resultData?.riskLevel]}
              disabled
              placeholder={t('LAST_BET_RISK')}
            />
          </div>
        </div>
        <div className='form-group mb-3'>
          <label className='form-label'>{t('LAST_BET_ROWS')}</label>
          <div className='input-group'>
            <input
              type='text'
              className='form-control shadow-none'
              style={{ paddingLeft: '1rem', paddingRight: '3.5rem' }}
              value={resultData?.numberOfRows}
              disabled
              placeholder={t('LAST_BET_ROWS')}
            />
          </div>
        </div>
        <hr />
        <h6 className='body-heading'>{t('GENERATE_NEW_CLIENT_SEED')}</h6>
        <div className='form-group'>
          <label className='form-label'>{t('NEXT_CLIENT_SEED')}</label>
          <div className='row gx-2'>
            <div className='col'>
              <div className='input-group'>
                <div
                  // type='text'
                  className='form-control py-1 shadow-none toast-body custom-text-field'
                  rows='1'
                  style={{ paddingLeft: '1rem', paddingRight: '1rem', width: '80%' }}
                  disabled
                  placeholder={t('NEXT_CLIENT_SEED')}
                >{updatedCLientSeed}</div>
              </div>
            </div>
            <div className='col-auto'>
              <button className='btn gradient-btn text-capitalize generate-btn' onClick={handleGenerateNewClientSeed}>
                {t('GENERATE')}
              </button>
            </div>
          </div>
        </div>
      </>
    )
  } else if (+gameId === +DEFAULT_GAME_ID.KENO) {
    return (
      <>
        <div className='form-group mb-3'>
          <label className='form-label'>{t('BET_CLIENT_SEED')}</label>
          <div className='input-group'>
            <input
              type='text'
              className='form-control shadow-none'
              style={{ paddingLeft: '1rem', paddingRight: '3.5rem' }}
              value={resultData?.clientSeed}
              disabled
              placeholder= {t('CLIENT_SEED')}
            />
            <div className='position-absolute top-0 bottom-0 end-0 custom-input-group-addons'>
              <button type='button' className='input-btn' onClick={() => handleCopyCode(resultData?.clientSeed)}>
                <CopyIcon width='22' height='22' fill='var(--themeGreyText)' />
              </button>
            </div>
          </div>
        </div>
        <div className='form-group mb-3'>
          <label className='form-label'>{t('BET_SERVER_SEED')}</label>
          <div className='input-group'>
            <input
              type='text'
              className='form-control shadow-none'
              style={{ paddingLeft: '1rem', paddingRight: '3.5rem' }}
              value={resultData?.serverSeed}
              disabled
              placeholder={t('SERVER_SEED')}
            />
            <div className='position-absolute top-0 bottom-0 end-0 custom-input-group-addons'>
              <button type='button' className='input-btn' onClick={() => handleCopyCode(resultData?.serverSeed)}>
                <CopyIcon width='22' height='22' fill='var(--themeGreyText)' />
              </button>
            </div>
          </div>
        </div>
        <hr />
        <h6 className='body-heading'>{t('GENERATE_NEW_CLIENT_SEED')}</h6>
        <div className='form-group'>
          <label className='form-label'>{t('NEXT_CLIENT_SEED')}</label>
          <div className='row gx-2'>
            <div className='col'>
              <div className='input-group'>
                <div
                  // type='text'
                  className='form-control py-1 shadow-none toast-body custom-text-field'
                  rows='1'
                  style={{ paddingLeft: '1rem', paddingRight: '1rem', width: '80%' }}
                  disabled
                  placeholder={t('NEXT_CLIENT_SEED')}
                >{updatedCLientSeed}</div>
              </div>
            </div>
            <div className='col-auto'>
              <button className='btn gradient-btn text-capitalize generate-btn' onClick={handleGenerateNewClientSeed}>
                {t('GENERATE')}
              </button>
            </div>
          </div>
        </div>
      </>
    )
  } else {
    return (
      <>
        <div className='form-group mb-3'>
          <label className='form-label'>{t('BET_CLIENT_SEED')}</label>
          <div className='input-group'>
            <input
              type='text'
              className='form-control shadow-none'
              style={{ paddingLeft: '1rem', paddingRight: '3.5rem' }}
              value={resultData?.[0]?.clientSeed}
              disabled
              placeholder={t('CLIENT_SEED')}
            />
            <div className='position-absolute top-0 bottom-0 end-0 custom-input-group-addons'>
              <button type='button' className='input-btn' onClick={() => handleCopyCode(resultData?.[0]?.clientSeed)}>
                <CopyIcon width='22' height='22' fill='var(--themeGreyText)' />
              </button>
            </div>
          </div>
        </div>
        <div className='form-group mb-3'>
          <label className='form-label'>{t('BET_SERVER_SEED')}</label>
          <div className='input-group'>
            <input
              type='text'
              className='form-control shadow-none'
              style={{ paddingLeft: '1rem', paddingRight: '3.5rem' }}
              value={resultData?.[0]?.serverSeed}
              disabled
              placeholder={t('SERVER_SEED')}
            />
            <div className='position-absolute top-0 bottom-0 end-0 custom-input-group-addons'>
              <button type='button' className='input-btn' onClick={() => handleCopyCode(resultData?.[0]?.serverSeed)}>
                <CopyIcon width='22' height='22' fill='var(--themeGreyText)' />
              </button>
            </div>
          </div>
        </div>
        <hr />
        <h6 className='body-heading'>{t('GENERATE_NEW_CLIENT_SEED')}</h6>
        <div className='form-group'>
          <label className='form-label'>{t('NEXT_CLIENT_SEED')}</label>
          <div className='row gx-2'>
            <div className='col'>
              <div className='input-group'>
                <div
                  // type='text'
                  className='form-control py-1 shadow-none toast-body custom-text-field mb-2'
                  rows='1'
                  style={{ paddingLeft: '1rem', paddingRight: '1rem', width: '80%' }}
                  disabled
                  placeholder={t('NEXT_CLIENT_SEED')}
                >{updatedCLientSeed}</div>
              </div>
            </div>
            <div className='col-auto'>
              <button className='btn gradient-btn text-capitalize generate-btn' onClick={handleGenerateNewClientSeed}>
                {t('GENERATE')}
              </button>
            </div>
          </div>
        </div>
      </>
    )
  }
}

export default SeedsTab
